// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BillingPost } from '../../../../types/server/modules/billing/post';

export type * from '../../../../types/server/modules/billing/post';

export const createPost = ( requests: Requests ): BillingPost => ({
  pay_my_subscription: Object.assign(( body,headers ) => {
      return requests.post( `/billing/pay-my-subscription`, { body }, headers );
    }, { operation: 'billing:pay-my-subscription', route: 'POST /billing/pay-my-subscription', subdomain: 'billing', visibility: 'private' } as const ),
  add_my_subscription_card: Object.assign(( body,headers ) => {
      return requests.post( `/billing/my-subscription/card-on-file`, { body }, headers );
    }, { operation: 'billing:add-my-subscription-card', route: 'POST /billing/my-subscription/card-on-file', subdomain: 'billing', visibility: 'private' } as const )
});
